import React from "react";
//Icons
 import { Table, Th, Thead, Tr, Td} from 'reactable';
import {appHelpers} from "../../_helpers";
import moment from "moment"
import ServerPaginatedTable from "../utils/pagination.server";
// import ProformaReportDownload from "./report-download";

const nairaCurrency =  String.fromCharCode(appHelpers.getCurrencyUnicode(566));
const dollarCurrency =  String.fromCharCode(appHelpers.getCurrencyUnicode(840));

const ReportTable = ({data, pageIndex}) =>{
        // let { data } = this.props;
        return (
            <div>
                <Table className="table table-striped table-hover" id="table" sortable={true}  >
                    <Thead>
                        <Th column="SN">S/N</Th>
                    <Th column="DOO">
                        <span>Date of Operation</span>
                    </Th>
                    <Th column="FlightNumber">
                        <span>Flight Number</span>
                    </Th>
                    <Th column="From">
                        <span>From</span>
                    </Th>
                    <Th column="To">
                        <span>To</span>
                    </Th>
                    <Th column="TOB">
                        <span>TOB</span>
                    </Th>
                    <Th column="INF">
                        <span>INF</span>
                    </Th>
                    <Th column="TTPDollar">
                        <span>{ `Amount (${dollarCurrency})`}</span>
                    </Th>
                    <Th column="TTPNaira">
                        <span>{`TTP (${nairaCurrency})`}</span>
                    </Th>
                    <Th column="AmountDollar">
                        <span>{`Amount (${dollarCurrency})`}</span>
                    </Th>
                    <Th column="AmountNaira">
                        <span>{`Amount (${nairaCurrency})`}</span>
                    </Th>
                    </Thead>

                    {data.map((item, i) => <Tr key={i}>
                        <Td column={"SN"}>{ `${pageIndex + i + 1}`  }</Td>
                        <Td column="DOO" className="text-capitalize">{moment(item.DateofOperation).format("YYYY-MM-DD")}</Td>
                        <Td column="FlightNumber">{item.FlightNumber}</Td>
                        <Td column="From">{item.DepartureLocation}</Td>
                        <Td column="To">{item.ArrivalLocation}</Td>
                        <Td column="TOB">{item.TotalPassengers}</Td>
                        <Td column="INF">{item.Infants}</Td>
                        <Td column="TTPDollar">{item.DollarPayingPassengerCount}</Td>
                        <Td column="TTPNaira">{item.NairaPayingPassengerCount}</Td>
                        <Td column="AmountDollar">{item.TotalServiceChageInDollars}</Td>
                        <Td column="AmountNaira">{item.TotalServiceChageInNaira}</Td>
                    </Tr>)}
                </Table>
            </div>
        )

};

class SecurityChargeReportTable extends React.Component {
    render() {
        const {  pageSize, currentPage, totalCount, data, fetchMore} = this.props;
        let pageIndex = (currentPage - 1) * pageSize;
        return (
            <div>
                <div className="row">
                <div className="col-md-12 col-sm-12 mb-4" >
                    <ServerPaginatedTable  currentPage={currentPage} fetchMore={fetchMore}
                                           target={<ReportTable data={data}  pageIndex={pageIndex}/>}
                                           pageSize={pageSize} totalCount={totalCount}

                    />
                </div>
            </div>
            </div>
        );
    }
}
export default SecurityChargeReportTable;

/* Written with love by Juliet Onyekaoha November 2019 */



// WEBPACK FOOTER //
// ./src/views/security-charge-report/report-table.js